@if (dataIsLoaded) {
  <div class="text-center">
    <div class="container">
      <h2 [innerHTML]="data.heading"></h2>
      @if (data.subheading) {
        <h3 [innerHTML]="data.subheading"></h3>
      }
      <p class="text-center" [innerHTML]="data.text"></p>
    </div>
    @if (data.athletes) {
      <div class="teamusana-card-flex">
        @for (item of data.athletes; track item) {
          <div class="card-flex-item">
            <div class="img-wrapper">
              <img [src]="item.image" class="w-100" alt="" />
              <div class="card-caption">
                <h3 class="mb-1">{{ item.name }}</h3>
                <p class="font-weight-light">{{ item.country }}, {{ item.sport }}</p>
              </div>
            </div>
          </div>
        }
      </div>
    }
    <h3>Global Partners</h3>
    <div class="teamusana-logo-flex">
      @for (item of data.logos; track item) {
        <div class="logo-flex-item">
          <img [src]="item.src" class="w-100" alt="" />
        </div>
      }
    </div>
    @if (data.linkUrl) {
      <div>
        <a href="{{ data.linkUrl }}" class="btn btn-primary" target="_blank"> {{ data.linkText }} </a>
      </div>
    }
  </div>
}
